import React, { useEffect } from "react";
import Styles from "./DashRecentOrderHistory.module.css";
import { Link, useNavigate } from "react-router-dom";
import { getRecentTransactionsAction } from "../../../../store/actions/dashboard/DashboardActions";
import ShimmerLoader from "../../../pages/ShimmerLoader/ShimmerLoader";
import { useDispatch, useSelector } from "react-redux";
import { format, parseISO } from "date-fns";

const DashRecentOrderHistory = React.memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { transactions, loading, error } = useSelector((state) => state.dashBoardRecentTransaction);
  console.log(`DashRecentOrderHistory`, transactions);

  //   const transactions =  [
  //     {
  //         "transaction_id": "txn83ebebf",
  //         "senders_id": 18,
  //         // "senders_name": "Prateek",
  //         "senders_phone": "8004037398",
  //         "transaction_type": "gifting",
  //         "gold_quantity": 0.5,
  //         "price_per_gram": 8568.93,
  //         "total_amount": 4284.465,
  //         "transaction_date": "2025-02-22T16:04:01.969245+05:30",
  //         "status": "completed",
  //         "created_at": "2025-02-22T16:04:01.969245+05:30",
  //         "receiver_id": 192,
  //         "receiver_name": "Areeb",
  //         "receiver_phone": "7317448807",
  //         "remarks": "",
  //         "reward_points": null
  //     },
  //     {
  //         "transaction_id": "txnc26340b",
  //         "senders_id": 18,
  //         "senders_name": "Prateek",
  //         "senders_phone": "8004037398",
  //         // "transaction_type": "gifting",
  //         "gold_quantity": 0.5,
  //         "price_per_gram": 8568.93,
  //         "total_amount": 4284.465,
  //         "transaction_date": "2025-02-22T16:01:40.247795+05:30",
  //         "status": "completed",
  //         "created_at": "2025-02-22T16:01:40.247795+05:30",
  //         "receiver_id": 192,
  //         "receiver_name": "Areeb",
  //         "receiver_phone": "7317448807",
  //         "remarks": "",
  //         "reward_points": null
  //     },
  //     {
  //         "transaction_id": "txn42bd9fb",
  //         "senders_id": 192,
  //         "senders_name": "Areeb",
  //         "senders_phone": "7317448807",
  //         "transaction_type": "in_store_redeem",
  //         "gold_quantity": 0.5,
  //         "price_per_gram": 8568.93,
  //         "total_amount": 4284.465,
  //         "transaction_date": "2025-02-22T13:00:28.445547+05:30",
  //         "status": "completed",
  //         "created_at": "2025-02-22T13:00:28.445547+05:30",
  //         "receiver_id": null,
  //         // "receiver_name": "",
  //         "receiver_phone": null,
  //         "remarks": "Redeemed successfully.",
  //         "reward_points": null
  //     }
  // ]
  //   const {  loading, error } = useSelector((state) => state.dashBoardRecentTransaction);
  //   console.log(`DashRecentOrderHistory`, transactions);

  useEffect(() => {
    dispatch(getRecentTransactionsAction({}, navigate));
  }, [dispatch]);

  const formatDate = (dateStr) => {
    const date = parseISO(dateStr);
    const addOrdinalSuffix = (day) => {
      const suffixes = ["th", "st", "nd", "rd"];
      const value = day % 100;
      return day + (suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0]);
    };
    // Get formatted date parts
    const day = addOrdinalSuffix(format(date, "d"));
    const month = format(date, "MMM");
    const year = format(date, "yyyy");
    const hour = format(date, "h:mm a");
    return `${day} ${month} ${year}, ${hour}`;
  };

  const transactionMessage = (trxType, sender, receiver) => {
    if (trxType.toLowerCase() == "gifting") {
      return `${sender} has gifted to ${receiver}`;
    } else if (trxType.toLowerCase() == "redeem") {
      return `${sender} has redeemed`;
    } else if (trxType.toLowerCase() == "reward") {
      return `${receiver} has received a reward`;
    } else if (trxType.toLowerCase() == "in_store_redeem") {
      return `${sender} has redeem from store`;
    }
    if (!trxType) {
      return "Transaction details not available";
    }
    if (!sender) {
      return `${receiver} has received from Unknown Sender  `;
    }
    if (!receiver) {
      return `${sender} has send to Unknown Receiver`;
    }
  };

  if (loading) {
    return <ShimmerLoader />;
  }
  return (
    <>
      <div className="card-body">
        <div className={`${Styles.dashboard_card} d-flex justify-content-between align-items-start mb-2`}>
          <p>Order History</p>
          <button className={`btn btn-primary  ${Styles.viewMore_button} `}>
            <Link to="/transactions">View More</Link>
          </button>
        </div>
        <hr />
        {transactions.length > 0 &&
          transactions.map(
            (
              {
                transaction_type = "",
                senders_name = "",
                senders_phone = "",
                receiver_name = "",
                receiver_phone = "",
                transaction_date,
                gold_quantity,
              },
              index
            ) => (
              <div
                key={index}
                className={`${Styles.order_history} d-flex justify-content-between align-items-start border-bottom my-3`}
              >
                <div className={`${Styles.order_details}`}>
                  <p>
                    {" "}
                    <span className="text-capitalize">
                      {" "}
                      {transactionMessage(
                        transaction_type,
                        senders_name ?? senders_phone,
                        receiver_name ?? receiver_phone
                      )}
                    </span>
                  </p>
                  <p>{formatDate(transaction_date)}</p>
                </div>
                <div className={`${Styles.text_success}`}>{gold_quantity} gm</div>
              </div>
            )
          )}
      </div>
    </>
  );
});

export default DashRecentOrderHistory;
